// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* BORDERS */\n\n/* Icons */\n\n/* BORDERS */\n\n/* Icons */\n.trial-table[data-v-228c34e8] {\n  width: 100%;\n  border-collapse: collapse;\n}\n.trial-list[data-v-228c34e8] {\n  list-style: disc;\n  padding-left: 20px;\n}", ""]);
// Exports
module.exports = exports;
